var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPutgas = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "liqubkqpya",
    d: "M0 0.147L23.9 0.147 23.9 34 0 34z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0z",
    transform: "translate(0 .5)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EFB726",
    d: "M28.923 3.889c0 1.78-1.443 3.227-3.22 3.227-1.78 0-3.225-1.447-3.225-3.227 0-1.78 1.445-3.222 3.224-3.222 1.778 0 3.221 1.442 3.221 3.222",
    transform: "translate(0 .5) translate(9.333 6.667)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .5) translate(9.333 6.667) translate(0 .536)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qq4zlbw0eb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#liqubkqpya"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M16.04 20.403c-1.653-1.796-3.054-3.878-3.06-4.548 0-.569-.462-1.032-1.03-1.032-.566 0-1.028.461-1.028 1.028-.006.67-1.412 2.76-3.068 4.563-2.176 2.41-3.203 4.911-3.058 7.433.022.404.073.803.155 1.186l.14.674-.474-.5c-1.098-1.16-1.85-2.457-2.235-3.857-1.062-3.819.48-8.439 4.579-13.731 1.026-1.183 2.065-2.504 2.937-3.735.765-1.075 1.396-2.077 1.879-2.98l.173-.326.173.327c.479.895 1.111 1.898 1.883 2.978 1.242 1.756 2.46 3.191 2.928 3.727 4.104 5.3 5.648 9.921 4.587 13.74-.388 1.404-1.141 2.7-2.239 3.856l-.469.5.137-.673c.086-.408.136-.797.157-1.184.142-2.527-.889-5.032-3.067-7.446M15.62 34c.125 0 .25-.024.368-.069.238-.092 5.92-2.34 7.507-8.004 1.255-4.493-.41-9.74-4.95-15.598l-.034-.037-.034-.039c-.249-.286-1.557-1.802-2.81-3.573-2.425-3.426-2.687-4.99-2.687-5.505 0-.566-.462-1.028-1.03-1.028-.566 0-1.028.462-1.028 1.028 0 2.088-3.386 6.693-5.522 9.105-.013.016-.027.031-.041.05C.815 16.186-.851 21.434.406 25.926c1.588 5.664 7.269 7.912 7.508 8.004.466.177.99 0 1.246-.425.257-.427.173-.976-.199-1.305-.017-.014-1.96-1.754-2.113-4.469-.114-1.959.736-3.955 2.522-5.934.675-.733 1.637-1.857 2.414-3.051l.166-.253.163.253c.908 1.39 2.075 2.677 2.41 3.038 1.783 1.982 2.637 3.972 2.535 5.916-.138 2.624-2.037 4.425-2.116 4.502-.374.332-.457.88-.201 1.303.183.305.521.494.879.494",
    mask: "url(#qq4zlbw0eb)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPutgas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_putgas.db4ad83641c642214dcaf5ebbb3b017c.svg";